module.exports = require('./cjs/nivo-voronoi')
